<template>
  <v-dialog v-model="dialog" max-width="720">
    <template v-slot:activator="{ on }">
      <v-btn color="error" class="ml-1" dark v-on="on"> Отклонить</v-btn>
    </template>

    <v-card class="elevation-12" :loading="loading">
      <v-card-title class="headline"> Подтвердите отклонение заказа</v-card-title>
      <v-card-text>
        <v-select
            v-model="form.reasonCode"
            :items="options"
            label="Причина отказа"
            item-text="name"
            item-value="id"
            :error-messages="declineOrderReasonCodeErrors"
            dense
            outlined
            :hide-details="declineOrderReasonCodeErrors.length === 0"
            :disabled="loading"
        />
      </v-card-text>
      <v-card-text>
        <v-textarea v-model="form.comment" outlined :dense="true" label="Причина отклонения" no-resize row-height="12" clearable :disabled="loading"/>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" dark @click="dialog = false" :disabled="loading" text>Закрыть</v-btn>
        <v-spacer/>
        <v-btn color="error" @click="onDeclineClicked" :disabled="loading" text>Отклонить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "vuelidate";
import * as DeclineOrderCodeType from "@/enum/OrderDeclineReasonType";
import {required} from "vuelidate/lib/validators";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import ReturnOrderService from "@/services/return.order.service";

export default {
  name: "DeclineReturnOrder",
  mixins: [validationMixin],
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      options: Object.keys(DeclineOrderCodeType).map(key => {
        return DeclineOrderCodeType[key]
      }),
      form: {
        reasonCode: null,
        comment: "",
      }
    }
  },
  computed: {
    declineOrderReasonCodeErrors() {
      const errors = []
      if (this.$v.form.reasonCode.$dirty)
        if (!this.$v.form.reasonCode.required)
          errors.push('Обязательно')

      return errors
    }
  },
  validations: {
    form: {
      reasonCode: {
        required
      }
    }
  },
  methods: {
    onDeclineClicked() {
      this.$v.form.reasonCode.$touch()
      if (!this.$v.form.$invalid) {
        this.$store.dispatch(LAYOUT_LOADING_START)
        this.loading = true
        ReturnOrderService.decline(this.id, {
          Reason: this.form.reasonCode,
          Comment: this.form.comment
        })
            .then(() => {
              this.dialog = false
              this.$emit("declined")
            })
            .catch((exception) => {
              window.console.log(exception)
            })
            .finally(() => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    }
  }
}
</script>

<style scoped>

</style>